import script from "./Works.vue?vue&type=script&setup=true&lang=js"
export * from "./Works.vue?vue&type=script&setup=true&lang=js"

import "./Works.vue?vue&type=style&index=0&id=567f7128&lang=scss&scoped=true"

import exportComponent from "D:\\SI1280\\project\\Vue-portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567f7128"]])

export default __exports__